// logo sliders ===========

var brand_sliderss = new Swiper(".brand_sliders", {
  slidesPerView: 2,
  spaceBetween: 40,
  loop: true,
  navigation: {
    nextEl: ".brand_slidr_btn .swiper-button-next",
    prevEl: ".brand_slidr_btn .swiper-button-prev",
  },
  breakpoints: {
    426: {
      slidesPerView: 3,
      spaceBetween: 50,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 60,
    },
    992: {
      slidesPerView: 5,
      spaceBetween: 70,
    },
    1024: {
      slidesPerView: 6,
      spaceBetween: 76,
    },
  },
});

// instagram slider =============

var instagram_sliderr = new Swiper(".instagram_slider", {
  slidesPerView: 2,
  spaceBetween: 5,
  autoplay: true,
  loop: true,
  breakpoints: {
    426: {
      slidesPerView: 2,
    },
    640: {
      slidesPerView: 3,
    },
    768: {
      slidesPerView: 4,
    },
    1024: {
      slidesPerView: 5,
    },
  },
});

// custom collection slider in 767 media screen =============

var custom_collection_mob_sliderr = new Swiper(
  ".custom_collection_mob_slider",
  {
    slidesPerView: 2,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      576: {
        slidesPerView: 4,
      },
    },
  }
);

// custom product slider =================

var cm_produvt_slidersr = new Swiper(".cm_produvt_sliders", {
  slidesPerView: 1,
  spaceBetween: 20,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    576: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
  },
});

// custom blogslider =================

var cm_blog_sliderr = new Swiper(".cm_blog_slider", {
  slidesPerView: 1,
  spaceBetween: 20,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    576: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    989: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
  },
});
